import { Pipe, PipeTransform } from '@angular/core';
import { RunTicket } from '../../_models/field';

@Pipe({ name: 'batteryFilter' })

export class BatteryFilterPipe implements PipeTransform {
  transform(tickets: RunTicket[], selectBatteries: any[]): any[] {
    if (!tickets) return [];
    if (selectBatteries.length == 0) return tickets;

    return tickets.filter(ticket => {
      if (selectBatteries.includes(ticket.batteryID)) {
        return ticket;
      }
    });
  }
}
